import { useTranslation } from 'react-i18next';

type Props = {
  error?: string;
  ns?: string;
};

export function FormErrorMessage({ error, ns = 'common' }: Props) {
  const { t } = useTranslation(ns);
  return <p className='min-h-5 text-red-500 text-sm'>{t(error as string)}</p>;
}
